<template>
  <div>
    <Application :isApplicant="$route.meta.applicant" />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

import Application from "./components/Application";
import { EventBus } from "@/services/event-bus";

export default {
  name: "ApplicationRoute",
  components: { Application },
  data() {
    return {
      pollingInterval: null
    };
  },
  created() {
    EventBus.$on("polling:setup", this.setOrClearPollingInterval);
  },
  destroyed() {
    EventBus.$off("polling:setup", this.setOrClearPollingInterval);
  },
  computed: {
    ...mapState("applicationStore", ["application"]),
    ...mapGetters("applicationStore", ["expandedActionsWithCommentsOpen"])
  },
  methods: {
    ...mapActions("applicationStore", ["getApplication", "getActionMessages"]),
    setOrClearPollingInterval() {
      if (
        this.expandedActionsWithCommentsOpen.length &&
        !this.pollingInterval
      ) {
        this.getActionMessages();
        this.pollingInterval = window.setInterval(this.getActionMessages, 3000);
      } else if (
        !this.expandedActionsWithCommentsOpen.length &&
        this.pollingInterval
      ) {
        window.clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    }
  }
};
</script>
